module.exports = __webpack_public_path__ + "img/dianxin006-1.3aa2cf31.png";